module.exports = __webpack_public_path__ + "img/dataforce-block-bg-right.5268b12f.svg";